// bfsg
import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import useTranslations from 'hooks/useTranslations'

type Props = {
  stock: number
}

export default function StockInfo(props: Props) {
  const t = useTranslations<'stockInfo'>()

  if (props.stock === 0) return null

  return (
    <Wrapper
      className="StockInfo"
      data-cy-state="available-stock"
      data-cy-ctx="StockInfo"
    >
      <span>{t('available_stock', { stock: props.stock })}</span>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  color: ${theme.colors.shade.b2};
  margin-bottom: ${theme.spacing('s')};
  ${theme.ty('r-s')}
`
